<template>
  <div class="tv-banners">
    <carousel id="tvBanners" class="tv-banners__wrapper" :responsive="carouselOptions">
      <li
        class="tv-banners__item"
        v-for="(banner, index) in banners"
        :key="index"
        @click="handleClick"
      >
        <router-link class="tv-banners__link" :to="banner.link" :title="banner.alt" :aria-label="banner.alt">
          <figure>
            <picture class="tv-banners__image">
              <source
                media="(min-width: 1370px)"
                :srcset="getBannerImg(index, 'xl')"
                :alt="banner.alt"
                :title="banner.title"
              />
              <source
                media="(min-width: 1025px)"
                :srcset="getBannerImg(index, 'lg')"
                :alt="banner.alt"
                :title="banner.title"
              />
              <source
                media="(min-width: 768px)"
                :srcset="getBannerImg(index, 'md')"
                :alt="banner.alt"
                :title="banner.title"
              />
              <img :src="getBannerImg(index, 'sm')" :alt="banner.name" />
            </picture>
            <figcaption class="tv-banners__caption">{{ banner.caption }}</figcaption>
          </figure>
        </router-link>
      </li>
    </carousel>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  name: "TVBanners",
  components: {
    carousel
  },
  data() {
    return {
      carouselOptions: {
        0: {
          items: 1,
          autoHeight: true,
          autoplay: false,
          autoplayTimeout: 3000,
          autoplayHoverPause: false,
          lazyLoad: true,
          nav: false,
          dots: false,
          loop: false,
          mouseDrag: false
        }
      },
      banners: [
        {
          name: "Banner TV 1",
          alt: "Imagem do primeiro banner TV",
          title: "Clique e saiba mais",
          caption: "",
          link: ""
        },
      ]
    };
  },
  methods: {
    getBannerImg: (bannerIndex, size) =>
      require(`../../assets/img/banner-TV-${bannerIndex + 1}__${size}.jpg`),
    handleClick: function() {
      const forms = document.querySelector(".home__area--forms");
      scrollTo(0, forms.offsetTop);
    }
  }
};
</script>

<style lang="scss">
.tv-banners {
  margin-top: $space__xs;

  &__item {
    position: relative;
    list-style: none;
  }

  &__link {
    text-decoration: none;
  }

  &__caption {
    &:not(:empty) {
      position: absolute;
      top: 50%;
      left: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      font-size: $font-size__sp3;
      color: $color__white;
      text-align: center;
      text-indent: $space__sm;
      text-shadow: $shadow__title;
      background: $color__overlay;
      transform: translate(-50%, -50%);
      z-index: 1;

      @include breakpoint($desk__min--sm) {
        font-size: $font-size__banner-caption;
      }
    }
  }

  #tvBanners {
    position: relative;

    .owl {
      &-height {
        min-height: 180px;

        @include breakpoint($mobile__min--md) {
          min-height: 210px;
        }

        @include breakpoint($tablet__min--sm) {
          min-height: 440px;
        }

        @include breakpoint($desk__min--lg) {
          min-height: 700px;
        }
      }
      &-item {
        img {
          max-width: 100%;
          margin: 0;
        }
      }

      &-dots {
        position: absolute;
        bottom: $space__st;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);
      }

      &-dot {
        width: $space__hg;

        &:active,
        &:focus {
          outline: none;
        }

        span {
          display: block;
          width: $space__st;
          height: $space__st;
          margin: 0 auto;
        }

        &.active {
          span {
            background: $color__primary;
          }
        }
      }
    }
  }
}
</style>
